import { globalStore } from '../../../common/redux.Interface.Store'
import { setImageUrl, setUserId, setEmail, setIsUserDataSet } from '../../../v2/store/users';

/**
 * Configures storage to finish the login process, sets required items on local storage and redux storage.
 * @param loginAuthResponse Server response on successful login attempt
 * @param identityProviderName Name of the identity provider { google | microsoft | guest }
 */
export function signInStorageHandler (
  loginAuthResponse,
  identityProviderName
) {

  if(identityProviderName === "guest")
  {
    console.log(loginAuthResponse)
  }
  if (
    loginAuthResponse &&
    loginAuthResponse.data
  ) {
    const formatIconMapping = (array) => {
      if (array?.length) {
        const formattedObject = {};
        const entityTypeColors = {};
        const industryTypeIcons = {};
        const executiveEntityMarkers = {};

        array.forEach(item => {
          const { endCustomerName, iconName, color, entityTypeId, industryTypeId, entityId } = item.json_build_object;
          const markerSetting = {
            color,
            icon: iconName ? iconName.split('-')[1] : null,
            style: iconName ? iconName.split('-')[0] : null
          };

          if (entityId) {
            executiveEntityMarkers[entityId] = markerSetting;
            return;
          }

          if (endCustomerName !== null) {
            formattedObject[endCustomerName] = markerSetting;
            return;
          }

          // todo - implement isFallbackMarker field in the backend in the future
          if (entityTypeId === null && industryTypeId === null && !formattedObject['Default Marker']) {
            formattedObject['Default Marker'] = markerSetting;
          }

          if (entityTypeId) entityTypeColors[entityTypeId] = { color };
          if (industryTypeId) industryTypeIcons[industryTypeId] = {
            color: markerSetting.color,
            icon: markerSetting.icon,
            style: markerSetting.style
          };
        });

        return { ...formattedObject, entityTypeColors, industryTypeIcons, executiveEntityMarkers };
      }
      return {};
    };

    window.localStorage.setItem('userId', loginAuthResponse.data.user_id)
    globalStore.dispatch(setUserId(loginAuthResponse.data.user_id))
    // The avatar is not available in the loginAuthResponse.data
    // window.localStorage.setItem('image_url', loginAuthResponse.data.avatar)
    window.localStorage.setItem(
      'mapCentralization',
      JSON.stringify({
        location_coordinates:
          loginAuthResponse.data.settings.location_coordinates,
        location_zoom:
          loginAuthResponse.data.application_state?.zoom ||
          loginAuthResponse.data.settings?.location_zoom
      })
    )
    // Dont Show Instruction on Heatmap
    const dontShowInstruction =
      loginAuthResponse?.data?.application_state?.dontShowInstruction || false
    window.localStorage.setItem('dontShowInstruction', dontShowInstruction)
    // isFirstTimeOnHeatmaps
    const isFirstTimeOnHeatmaps = loginAuthResponse?.data?.application_state?.isFirstTimeOnHeatmaps
    isFirstTimeOnHeatmaps !== null && isFirstTimeOnHeatmaps !== undefined && window.localStorage.setItem('isFirstTimeOnHeatmaps', isFirstTimeOnHeatmaps)
    // Icon Mapping
    window.localStorage.setItem(
      'iconMapping',
      JSON.stringify(formatIconMapping(loginAuthResponse.data.icon_mapping))
    )
    //Guest Login does not contain the token in the AuthResponse
    if (loginAuthResponse.data.jwt_token)
    {
      window.localStorage.setItem('token', loginAuthResponse.data.jwt_token)
    }
    window.localStorage.setItem('email', loginAuthResponse.data.email)
    globalStore.dispatch(setEmail(loginAuthResponse.data.email))
    window.localStorage.setItem(
      'welcomeMessage',
      JSON.stringify(loginAuthResponse.data.welcome_message)
    )

    window.localStorage.setItem(
      'fontStyleSelect',
      loginAuthResponse.data.settings.font_name
    )
    window.localStorage.setItem(
      'iconsSelect',
      loginAuthResponse.data.settings.icon_set_name
    )
    window.localStorage.setItem(
      'colorSelect',
      loginAuthResponse.data.settings.theme_name
    )

    if (loginAuthResponse.data.avatar) {
      window.localStorage.setItem('image_url', loginAuthResponse.data.avatar)
      globalStore.dispatch(setImageUrl(loginAuthResponse.data.avatar))
    }

    window.localStorage.setItem('first_time', loginAuthResponse.data.first_time)
    if (
      loginAuthResponse.data.application_state &&
      loginAuthResponse.data.application_state.activeTab
    ) {
      window.localStorage.setItem(
        'activeTab',
        loginAuthResponse.data.application_state.activeTab
      )
    }

    globalStore.dispatch(setIsUserDataSet(true));
  }

  // Set identity provider name
  window.localStorage.setItem('identityProvider', identityProviderName)

  if (loginAuthResponse.data.first_time === true) {
    window.localStorage.setItem('searchedString', '')
  } else if (loginAuthResponse.data.first_time === false) {
    if (
      loginAuthResponse.data.application_state?.searchedString === undefined ||
      loginAuthResponse.data.application_state?.searchedString === 'null'
    ) {
      window.localStorage.setItem('searchedString', '')
    } else {
      window.localStorage.setItem(
        'searchedString',
        loginAuthResponse.data.application_state.searchedString
      )
      window.localStorage.setItem(
        'in',
        loginAuthResponse.data.application_state?.mapBounds || null
      )
    }
  }
}
